function formatPermisConsolideTimestamps(root = document) {
  const nodes = root.querySelectorAll('[data-generated-at-utc]');

  nodes.forEach((node) => {
    const raw = node.getAttribute('data-generated-at-utc');
    if (!raw) return;

    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return;

    node.textContent = new Intl.DateTimeFormat(undefined, {
      dateStyle: 'short',
      timeStyle: 'short'
    }).format(date);
  });
}

function initPermisConsolideTimestamps() {
  formatPermisConsolideTimestamps();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        const element = node;
        if (element.matches?.('[data-generated-at-utc]')) {
          formatPermisConsolideTimestamps(element.parentElement || element);
        } else if (element.querySelector?.('[data-generated-at-utc]')) {
          formatPermisConsolideTimestamps(element);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('turbo:load', initPermisConsolideTimestamps);
document.addEventListener('DOMContentLoaded', initPermisConsolideTimestamps);
